import { Link } from 'react-router';
import logo from '../assets/hisphere-logo.png';

const Header = () => {
  return (
    <header className='glass-header text-white py-5 sticky top-0 z-20'>
        <div className='container mx-auto px-8 max-w-7xl flex items-center justify-between'>
          <Link to='/' className='flex items-center gap-4 cursor-pointer group'>
            <img
              src={logo}
              alt='HiSphere'
              className='w-20 h-20 rounded-full object-cover transition-transform duration-300 group-hover:scale-105'
            />
            <h1 className='text-2xl font-montserrat font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-cyan-300'>
              HiSphere
            </h1>
          </Link>
          <nav className='hidden md:flex gap-8 text-sm font-semibold tracking-wide'>
            <Link to='/solutions' className='hover:text-cyan-300 transition-colors duration-200'>Решения</Link>
            <Link to='/contact' className='hover:text-cyan-300 transition-colors duration-200'>Контакты</Link>
            <Link to='/about' className='hover:text-cyan-300 transition-colors duration-200'>О нас</Link>
          </nav>
        </div>
      </header>
  );
};

export default Header;
